/* eslint-disable prettier/prettier */
import React from 'react'
import { MdArrowBack } from 'react-icons/md'
import history from '../../../lib/history'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import Text from '../../commons/Text/Text'
import Button from '../../commons/Button/Button'
import Flex from '../../commons/Flex/Flex'
import styles from './termsInternal.module.scss'

const TermsContainer = () => {
  return (
    <ExternalLayout hideMenu>
      <Flex
        column
        style={{
          maxHeight: 530,
          overflowY: 'scroll',
          marginBottom: 20,
          paddingRight: 30
        }}
      >
        <Text
          bold
          size="lg"
          color="gray"
          vari="dark"
          lineHeight="28px"
          margin="0 0 24px"
        >
          TERMO DE RESPONSABILIDADE DE USO E DIREITO DE ACESSO AO PORTAL
          CONSULTOR MAIS
        </Text>

        <Text
          size="xs"
          color="gray"
          variation="dark"
          margin="0 0 16px"
          lineHeight="24px"
        >
          Este Termo de Responsabilidade de Uso e Direito de Acesso ao Portal
          Consultor Mais pauta-se pelos princípios da Política de Segurança da
          Informação, das Normas de Conduta e do Código de Ética e Educação
          Corporativa do Banco Santander (Brasil) S/A. e suas Coligadas
          (“Santander”) e visa preservar a integridade, confidencialidade,
          disponibilidade das informações sob gestão da Aymoré Crédito,
          Financiamento e Investimento S/A. e o uso e o direito ao conteúdo.
          Visa ainda alertar o usuário sobre sua responsabilidade no manuseio de
          material de forma que não contrarie o disposto na legislação vigente,
          a moral e os bons costumes e a ordem pública.
        </Text>

        <ol className={styles.list}>
          <li>
            Declaro, como de meu uso exclusivo, o acesso recebido do Santander
            para os conteúdos e informações presentes no Portal Consultor Mais e
            assumo a responsabilidade por todas as transações efetuadas sob esse
            código de identificação, cuja senha é de meu uso pessoal e
            intransferível. Comprometo-me a assumir a responsabilidade por todas
            as transações efetuadas sob minha senha de acesso.
          </li>
          <li>
            Declaro estar ciente de que este Termo é aplicável a todas as
            informações sob gestão do Santander a que venha ter acesso pelo
            Portal Consultor Mais, seja qual for a forma apresentada ou o meio
            qual a informação seja apresentada ou compartilhada.
          </li>
          <li>
            Estou ciente de que as funcionalidades disponibilizados no Portal
            Consultor Mais colocados à minha disposição são de exclusiva
            propriedade ou direito de uso do Santander, tendo este minha
            permissão prévia para acesso e monitoramento das atividades por mim
            realizadas no ambiente do Portal Consultor Mais, bem como quaisquer
            informações veiculadas e armazenadas nos referidos sistemas
            informatizados.
          </li>
          <li>
            Declaro estar ciente de que os acessos realizados no Portal
            Consultor Mais, bem como o conteúdo das mensagens compartilhadas no
            ambiente são monitoradas.
          </li>
          <li>
            Estou igualmente ciente das minhas responsabilidades no uso e
            direito de acesso aos conteúdos, e comprometo-me a cumprir as
            condutas:
          </li>
          <li>
            <ul>
              <li>
                de utilização das informações do Santander, ou das expressadas
                em nome deste, somente no interesse do serviço, não podendo
                divulga-las a terceiros sem expressa autorização do respectivo
                gestor ou comentá-las fora dos ambientes físicos e lógicos da
                empresa;
              </li>
              <li>
                de manutenção e sigilo sobre as informações sensíveis do
                Santander e considerar confidenciais todos os dados e
                informações, pormenores, especificações técnicas ou comerciais,
                inovações e aperfeiçoamentos dos quais venha a tomar
                conhecimento, ou que me venham a ser confiados, não podendo, sob
                qualquer pretexto, reproduzir, divulgar, enviar, ceder, dar
                conhecimento a terceiros;
              </li>
              <li>
                de não formar palavras ou expressões que gerem duplo sentido,
                que não sejam condizentes com o ambiente corporativo ou que
                possam causar danos à imagem do Santander ou de funcionários,
                colaboradores, contratados e clientes dessa instituição, nos
                ambientes colaborativos;
              </li>
              <li>
                de respeito aos direitos de propriedade intelectual, de acordo
                com a regulamentação pertinente.
              </li>
            </ul>
          </li>
          <li>
            Declaro, ainda, estar ciente que: O Santander se resguarda o direito
            de suspender meu acesso aos seus sistemas informatizados a qualquer
            momento, ainda que sem prévia comunicação, manifestando, desde já,
            minha concordância com essa medida.
          </li>
          <li>Reconheço ainda:</li>
          <li>
            <ul>
              <li>
                a propriedade, o direito exclusivo e a titularidade do Santander
                relacionados ao direito autoral, não podendo reproduzi-los,
                total ou parcialmente;
              </li>
              <li>
                que o Santander poderá introduzir modificações nas normas e
                regras que disciplinam a utilização do Portal Consultor Mais,
                divulgando-as aos usuários por meio de comunicação escrita ou
                eletrônica. Com isso dou por recebidas, certas e aceitas essas
                modificações quando de meu acesso ao Portal Consultor Mais.
              </li>
            </ul>
          </li>
          <li>
            {' '}
            E por estar de acordo com o presente Termo, assino-o
            eletronicamente.
          </li>
        </ol>

        <Text
          bold
          size="lg"
          color="gray"
          variation="dark"
          lineHeight="28px"
          margin="0 0 24px"
        >
          TERMO DE COMPROMISSO DE CONFIDENCIALIDADE – PORTAL CONSULTOR MAIS
        </Text>

        <Text
          size="xs"
          color="gray"
          variation="dark"
          margin="0 0 16px"
          lineHeight="24px"
        >
          Declaro o compromisso de manter confidencialidade e sigilo sobre todas
          as informações, anotação, especificações, documentos ou quaisquer
          outros dados de clientes, prospects, funcionários, prestadores de
          serviços, contratos e propostas de clientes e/ou quaisquer outras
          informações do Banco Santander (Brasil) S.A. e suas Coligadas
          doravante denominado “SANTANDER”, cujos acessos tenham sido
          autorizados a mim para fins de realização de meu trabalho, doravante
          denominados genericamente “INFORMAÇÕES”. Das obrigações assumidas pelo
          profissional declarante:
        </Text>
        <ol className={styles.list}>
          <li>
            Obrigo-me a utilizar as INFORMAÇÕES exclusivamente para os fins aos
            quais elas me foram divulgadas.
          </li>

          <li>
            Não divulgarei e/ou repassarei a pessoas não autorizadas e por
            qualquer meio, inclusive verbal, as INFORMAÇÕES a que tenho acesso
            através do Portal Consultor Mais, sistema do SANTANDER, sendo que a
            violação deste Termo restará configurada mesmo sem que haja o
            intuito de gerar benefício próprio ou de terceiros, presente ou
            futuro, por meio da divulgação indevida.
          </li>

          <li>
            Não fornecerei informações de usuário e senha, pois os mesmos são
            pessoais e intransferíveis.
          </li>

          <li>
            Reconheço que a violação de quaisquer das obrigações mencionadas
            neste TERMO sujeitar-me-á ao ressarcimento de perdas e danos à
            Companhia e/ou terceiros, incluindo danos à imagem, bem como outras
            penalidades cabíveis, cíveis e criminais, nos termos da lei.
          </li>

          <li>
            Caso eu seja obrigado a revelar qualquer Informação Confidencial por
            determinação legal de autoridade competente, deverei, previamente à
            divulgação de tal informação, notificar a Vice Presidência de
            Assuntos Jurídicos e Ouvidoria da Banco Santander (Brasil) S.A.
            acerca de tal fato, com a antecedência necessária para adoção das
            medidas cabíveis, em juízo ou fora dele, para evitar ou minimizar
            tal divulgação. Também me comprometo, caso obrigado por determinação
            legal, a não divulgar qualquer Informação Confidencial além daquelas
            estritamente solicitadas.
          </li>

          <li>
            Concordo que a demora ou não exercício, pelo SANTANDER, de qualquer
            prerrogativa ou direito previsto neste Termo não representa renúncia
            dos seus direitos. Da mesma forma, qualquer exercício isolado ou
            parcial de qualquer prerrogativa do SANTANDER não limitará o
            exercício integral de tal prerrogativa ou qualquer outro direito
            aqui previsto.
          </li>

          <li>
            O descumprimento do presente TERMO sujeitará às penalidades
            disciplinares correlatas (inclusive rescisão contratual), sem
            prejuízo das demais medidas legais cabíveis, inclusive
            responsabilização civil e criminal, e indenização em razão de danos
            decorrentes de quebra se sigilo/uso indevido das INFORMAÇÕES.
          </li>

          <li>
            As obrigações previstas neste TERMO, em razão de sua natureza,
            permanecerão em vigor por prazo indeterminado, mesmo após o término
            ou rescisão do contrato.
          </li>

          <li>
            O presente Termo está constituído sob as leis da República
            Federativa do Brasil, e fica eleito o foro central de São Paulo -
            SP, com renúncia de qualquer outro, por mais privilegiado que seja.
          </li>
        </ol>
      </Flex>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: 24
        }}
      >
        <Button
          type="outlined_dark"
          buttonType="button"
          onClick={() => history.goBack()}
          width="160px"
          margin="0px 10px 0px 0px"
        >
          <MdArrowBack />
          Voltar
        </Button>
      </div>
    </ExternalLayout>
  )
}

export default TermsContainer
